import Vue from 'vue'

// 按需引入
import {
  Button,
  ButtonGroup,
  Table,
  TableColumn,
  Menu,
  MenuItem,
  Pagination,
  Descriptions,
  DescriptionsItem,
  Divider,
  Input,
  Select,
  Option,
  Row,
  Col,
  Message,
  MessageBox,
  Carousel,
  CarouselItem,
  Container,
  Aside,
  Main,
  Form,
  FormItem,
  Loading,
  Image,
  Dialog,
  Avatar,
  Card
} from 'element-ui'

Vue.component(Button.name, Button)
Vue.component(ButtonGroup.name, ButtonGroup)
Vue.component(Table.name, Table)
Vue.component(TableColumn.name, TableColumn)
Vue.component(Menu.name, Menu)
Vue.component(MenuItem.name, MenuItem)
Vue.component(Pagination.name, Pagination)
Vue.component(Descriptions.name, Descriptions)
Vue.component(DescriptionsItem.name, DescriptionsItem)
Vue.component(Divider.name, Divider)
Vue.component(Input.name, Input)
Vue.component(Select.name, Select)
Vue.component(Option.name, Option)
Vue.component(Row.name, Row)
Vue.component(Col.name, Col)
Vue.component(Message.name, Message)
Vue.component(MessageBox.name, MessageBox)
Vue.prototype.$message = Message
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.component(Carousel.name, Carousel)
Vue.component(CarouselItem.name, CarouselItem)
Vue.component(Container.name, Container)
Vue.component(Aside.name, Aside)
Vue.component(Main.name, Main)
Vue.component(Form.name, Form)
Vue.component(FormItem.name, FormItem)
Vue.component(Image.name, Image)
Vue.component(Dialog.name, Dialog)
Vue.use(Loading)
Vue.component(Avatar.name, Avatar)
Vue.component(Card.name, Card)
